<template>


  <div class="container">

    <div class="title-view">预览</div>
    <textarea class="text-area"
              placeholder="助理说什么，你来定制"
              v-model="message"
              @input="input"
              maxlength="40"
    >

    </textarea>

    <div class="bottom-layout">
      <div :class="hasInput? 'open_button' : 'op-view_disable'" @click="onSave()">保存并设为开场白</div>
    </div>

  </div>

</template>

<script>

import TitleBarStore from '@/components/widgets/TitleBarStore'
import app from '@/AppData'
import jsbridge from '@/jsbridge'
import lubanapi from '@/lubanapi'

const PROLOGUE_CUSTOM_STORAGE_KEY = 'PROLOGUE_CUSTOM_STORAGE_KEY'
export default {
  name: 'VipPrologueEditPage',

  data () {
    return {
      message: this.$route.params.value,
      hasInput: false
    }
  },

  methods: {

    onSave () {
      console.log(this.message)
      if (!this.message) {
        // Toast
        return
      }
      if (!app.isVip()) {
        // 非会员
        jsbridge.showVipGuideDialog(this)
        return
      }
      app.setUserCustomContent({firstTalk: this.message})
      app.putLocalStorage(PROLOGUE_CUSTOM_STORAGE_KEY, this.message)
      app.reportCustomContent().then(value => {
        console.log('reportCustomContent success')
        // 返回
        this.$router.go(-1)
      }, reason => {
        console.log('reportCustomContent fail, reason:' + JSON.stringify(reason))
        // Toast
      })
      lubanapi.reportseer('AICall_Opening_Remarks_Setting_Customize_Edit_Page_Determine_Button_Click', app.isVip() ? '1' : '0')
    },

    input () {
      this.hasInput = this.message.length > 0 ? true : false
    }
  },

  mounted () {
    this.hasInput = this.message.length > 0 ? true : false
    TitleBarStore.store.showvipicon()
  }

}
</script>
<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>

.container {
  width: 100%;
  height: 100%;
  background-color: #F7F7F9;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.title-view {
  width: 100%;
  font-size: 0.8rem;
  color: #999999;
  text-align: left;
  padding-left: 1.2rem;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  box-sizing: border-box;
}

.text-area {
  width: 90%;
  height: 10rem;
  border: 0.05rem solid #DDDDDD;
  border-radius: 0.4rem;
  resize: none;
  padding: 0.8rem;
  box-sizing: border-box;
  font-size: 1.2rem;
  box-sizing: border-box;
}

.bottom-layout {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
}

.op-view_disable {
  width: 90%;
  height: 3rem;
  background-color: #DDDDDD;
  border-radius: 0.3rem;
  box-sizing: border-box;
  text-align: center;
  line-height: 3rem;
  font-size: 1rem;
  box-sizing: border-box;
  font-family: PingFangSC-Regular;
  color: #FFFFFF;
  text-align: center;
  margin-bottom: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/setting/VipPrologueEditPage.vue